const anyContentRegex = /.+/;
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const positiveInt = /^[1-9]\d*$/;
const whiteSpaceRegex = /\s/;
const isNameValidRegex = /^[A-Za-z\s-]+$/;
const isSpecialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
const isNumberRegex = /[0-9]/;
export {
  isNameValidRegex,
  isSpecialCharRegex,
  isNumberRegex,
  anyContentRegex,
  emailRegex,
  positiveInt,
  whiteSpaceRegex
};
